/**
 * "auto" on a drop's cell that follows the container's rule rather than a
 * choice made on this drop (user, 20/10/2026: "when it's automatic, say it's
 * automatic on the row") — the cell then shows what the rule gives this
 * drop today. A choice made here shows a pin instead.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

export const AutoTag: FC<{ title: string }> = ({ title }) => (
  <span
    title={title}
    className="shrink-0 rounded border border-border bg-muted/60 px-1 text-[9px] font-semibold uppercase leading-[14px] tracking-wide text-muted-foreground"
  >
    auto
  </span>
);
